import { render } from "./WidgetCategoryStats.vue?vue&type=template&id=7296a8bf&scoped=true"
import script from "./WidgetCategoryStats.vue?vue&type=script&lang=js"
export * from "./WidgetCategoryStats.vue?vue&type=script&lang=js"

import "./WidgetCategoryStats.vue?vue&type=style&index=0&id=7296a8bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7296a8bf"]])

export default __exports__